(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement-bar-countdown[data-end-time]').forEach(function (bar) {
      if (bar.dataset.countdownInit) return;
      bar.dataset.countdownInit = 'true';

      var timerEl = bar.querySelector('[data-timer-value]');
      var raw = bar.dataset.endTime;
      var endTime = raw ? new Date(raw) : null;
      if (!endTime || isNaN(endTime.getTime())) {
        endTime = new Date(Date.now() + 24 * 60 * 60 * 1000);
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        if (!timerEl) return;
        var diff = Math.max(0, endTime - new Date());
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        timerEl.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        if (diff <= 0) {
          clearInterval(intervalId);
          bar.style.display = 'none';
        }
      }

      tick();
      var intervalId = setInterval(tick, 1000);

      var mobileTexts = bar.querySelectorAll('.announcement-bar-countdown__mobile-text');
      if (mobileTexts.length > 1) {
        var idx = 0;
        setInterval(function () {
          mobileTexts[idx].classList.remove('is-active');
          idx = (idx + 1) % mobileTexts.length;
          mobileTexts[idx].classList.add('is-active');
        }, 3000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
